import { FC } from 'react';

import { NEXT_WEEK_FORMATTED, TODAY_FORMATTED } from 'utils/date';

import multicreationBackButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_back_button_click';
import multicreationNextButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_next_button_click';
import { ActionBar, Button, ProgressBar, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { fetchVacancySearch } from 'components/MultiCreationAuction/VacanciesFiltersPanel/fetchVacancySearch';

import { BiddingStrategy } from 'store/models/auctionData';
import {
    AuctionCreateFieldKey,
    MultiCreationAuctionSteps,
    setMultiCreationActiveStep,
    setMultiCreationBiddingStrategy,
    setMultiCreationBidsToRecommended,
    setMultiCreationVacanciesAuctionInfo,
    updateMultiCreationField,
} from 'store/models/multiCreation';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/MultiCreationAuction/BiddingStrategySelect/components/BiddingStrategySelectBottomPanel/BiddingStrategySelectBottomPanel.module.less';

const TrlKeys = {
    back: 'MultiCreationAuction.back',
    next: 'MultiCreationAuction.next',
};

export const BiddingStrategySelectBottomPanel: FC = () => {
    const biddingStrategy = useSelector(({ multiCreation }) => multiCreation.biddingStrategy);
    const selectedVacancyIds = useSelector(({ multiCreation }) => multiCreation.selectedVacancyIds);

    const { isMobile } = useBreakpoint();
    const trls = useTrls();
    const dispatch = useDispatch();

    const progressBar = <ProgressBar progress={2} segments={3} />;

    const handleNextClick = () => {
        multicreationNextButtonClick({
            currentStep: MultiCreationAuctionSteps.BiddingStrategySelectStep,
            biddingStrategy,
            vacancyIds: Object.keys(selectedVacancyIds).toString(),
        });
        dispatch([
            updateMultiCreationField({
                fieldKey: AuctionCreateFieldKey.StartAt,
                newValue: biddingStrategy === BiddingStrategy.Auto ? TODAY_FORMATTED : null,
            }),
            updateMultiCreationField({
                fieldKey: AuctionCreateFieldKey.EndAt,
                newValue: biddingStrategy === BiddingStrategy.Auto ? NEXT_WEEK_FORMATTED : null,
            }),
            setMultiCreationBidsToRecommended(),
            setMultiCreationActiveStep(MultiCreationAuctionSteps.BidsAndBudgetsStep),
        ]);
    };

    const handleBackClick = () => {
        multicreationBackButtonClick({ currentStep: MultiCreationAuctionSteps.BiddingStrategySelectStep });
        void dispatch(fetchVacancySearch({}));

        dispatch([
            setMultiCreationVacanciesAuctionInfo({
                auctionsToCreate: {},
                vacanciesAuctionInfo: null,
            }),
            setMultiCreationBiddingStrategy(BiddingStrategy.Auto),
            setMultiCreationActiveStep(MultiCreationAuctionSteps.VacanciesSelectStep),
        ]);
    };

    return (
        <>
            <ActionBar
                type={isMobile ? 'vertical' : 'horizontal'}
                isSticky
                showProgress={progressBar}
                additionalContent={isMobile ? <div className={styles.progressBar}>{progressBar}</div> : null}
                primaryActions={
                    <Button data-qa="next-button" mode="primary" style="accent" onClick={handleNextClick}>
                        {trls(TrlKeys.next)}
                    </Button>
                }
                secondaryActions={
                    <Button data-qa="back-button" mode="secondary" style="accent" onClick={handleBackClick}>
                        {trls(TrlKeys.back)}
                    </Button>
                }
            />
        </>
    );
};
